import type { Announcements } from "@dnd-kit/core";

/** For a dnd-kit context whose own `LiveRegion` speaks, so dnd-kit's stays quiet. */
export const SILENT_DND_ANNOUNCEMENTS: Announcements = {
    onDragStart: () => undefined,
    onDragOver: () => undefined,
    onDragEnd: () => undefined,
    onDragCancel: () => undefined,
};
